export default function (to: string, base: string) {
  const baseUrl = new URL(base)
  const toUrl = new URL(to, base)
  return baseUrl.host !== toUrl.host
}
